export default async function usePaginationWithIndices() {
  const paginationData = await usePagination({})

  const { currentPage, paginationQuery, validatePage } = paginationData
  const parseIndicesWithPagination = (res) => {
    const total = parseInt(res?.nbSortedHits || res?.nbHits || 0)
    const stories = res?.hits || []
    validatePage(currentPage.value + '', res?.nbPages)
    return {
      total,
      stories,
    }
  }

  const searchPagination = computed(() => ({
    page: paginationQuery.value.page - 1,
    hitsPerPage: paginationQuery.value.per_page,
  }))

  return { parseIndicesWithPagination, searchPagination, ...paginationData }
}
